<template>
  <div>
    <FilterForm v-model="filters" @reset="reset"/>

    <hr class="tw-mx-0 tw-my-8">

    <FeaturedStatistics :filters="filters" :portal-company="portalCompany"/>

    <TrendedRenderCounts :filters="filters" :portal-company="portalCompany"/>

    <RankedContent :filters="filters" :portal-company="portalCompany"/>

    <TrendedPublications :filters="filters" :portal-company="portalCompany"/>

    <PublishedContent :filters="filters" :portal-company="portalCompany"/>

    <TopRenderedContent :filters="filters" :portal-company="portalCompany"/>
  </div>
</template>

<script>
import moment from 'moment'
import FeaturedStatistics from "./DashboardWidgets/FeaturedStatistics.vue";
import FilterForm from './DashboardWidgets/FilterForm'
import Permissions from '@/mixins/Permissions'
import TrendedRenderCounts from "./DashboardWidgets/TrendedRenderCounts.vue";
import TrendedPublications from "./DashboardWidgets/TrendedPublications.vue";
import TopRenderedContent from "./DashboardWidgets/TopRenderedContent.vue";
import RankedContent from "./DashboardWidgets/RankedContent.vue";
import PublishedContent from "./DashboardWidgets/PublishedContent.vue";

export default {
  components: {
    RankedContent,
    PublishedContent,
    FeaturedStatistics,
    TrendedPublications,
    TrendedRenderCounts,
    FilterForm,
    TopRenderedContent
  },

  mixins: [Permissions],

  props: {
    portalCompany: {
      required: true
    }
  },

  data() {
    return {
      filters: {
        from: moment().format('YYYY-MM'),
        to: moment().format('YYYY-MM'),
      }
    }
  },

  methods: {
    reset() {
      this.filters = {
        from: moment().format('YYYY-MM'),
        to: moment().format('YYYY-MM'),
      }
    },
  }
}
</script>
